import styled from 'styled-components';

export const Input = styled.input`
  padding: 8px;
  font-size: 16px;
  border: 0;
  outline: none;
  height: 22px;
  background: ${props => props.theme.inputBackground || 'white'};
  background: ${({ disabled, theme }) => (disabled && `${theme.disabledInputBackground} !important`)};
  width: ${props => (typeof props.width === 'number' ? `${props.width}px` : props.width)};

  ::-ms-clear {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    width: 99%;
  }
`;
